"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "strict", "onChange", "uppercase"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputString/index.js";
var noop = function noop() {};
var defaultProps = {
  type: 'text',
  strict: false,
  onChange: noop
};
function InputString(_ref) {
  var className = _ref.className,
    strict = _ref.strict,
    onChange = _ref.onChange,
    uppercase = _ref.uppercase,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    // Normalize the value to Canonical Composition (NFC) form to handle different representations of characters like Ñ
    var value = e.target.value.normalize("NFC");
    var character = value.charAt(value.length - 1);
    // only string
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }
    if (uppercase) {
      e.target.value = value.toUpperCase();
    }
    onChange(e.target.value);
  }
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    className: (0, _classNames["default"])('form-control', className),
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }));
}
InputString.defaultProps = defaultProps;
var _default = exports["default"] = InputString;